import { type ComponentProps, forwardRef } from 'react'

import { Field } from '@/shared/ui/Form/Field/index'
import { Input } from '@/shared/ui/Form/TextField/styles'

export type TextFieldProps = ComponentProps<typeof Input> & {
  label: string
  error?: string
}

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ label, error, className, ...props }, ref) => {
    return (
      <Field label={label} error={error}>
        <Input id={label} type="text" {...props} ref={ref} />
      </Field>
    )
  },
)

TextField.displayName = 'TextField'
